import type { ContentReportItemDto } from '@/data/dtos/report/contentReportItemDto';
import type { JsonObject } from '@/data/types/json';
import type { ContentReportItemEntity } from '@/domain/entities/report/contentReportItemEntity';

export class ContentReportItemRemapper {
  static fromJson(data: JsonObject): ContentReportItemDto {
    return {
      id: (data['id'] as string | undefined) || '',
      parentId: (data['parentId'] as string | null | undefined) ?? null,
      title: (data['title'] as string | undefined) || '',
      description: (data['description'] as string | null | undefined) ?? null,
      order: (data['order'] as number | undefined) || 0,
      isSubmit: (data['isSubmit'] as boolean | undefined) ?? false,
    };
  }

  static toEntity(data: any): ContentReportItemEntity {
    const dto = this.fromJson(data);
    return { ...dto } as ContentReportItemEntity;
  }

  static fromJsonList(dataList: JsonObject[]): ContentReportItemEntity[] {
    return dataList.map(data => this.toEntity(data));
  }
}
